import React, { useState, useEffect } from "react";
/* global gdAlertify */
import axiosInstance from "../../../config/axiosConfig";
import { formatMoney, formatDateTime } from "../../../utils/utils";
import BonosCargaModal from "./BonosCargaModal";

// Lista los bonos cargados en el periodo/tipo actual, con opción de Eliminar o Resubir (reemplazar) cada carga.
const BonosListadoModal = ({ visible, onClose, periodo, tipo, resultadosBase, onChange }) => {
    const [bonos, setBonos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [eliminandoId, setEliminandoId] = useState(null);
    const [bonoAResubir, setBonoAResubir] = useState(null);

    const fetchBonos = async () => {
        if (!periodo) return;
        setLoading(true);
        try {
            const resp = await axiosInstance.get(`/liquidacion/${periodo}/bonos`, { params: { tipo } });
            setBonos(resp.data?.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (visible) fetchBonos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible, periodo, tipo]);

    if (!visible) return null;

    const handleEliminar = (bono) => {
        gdAlertify.confirm({
            title: `¿Eliminar bono "${bono.glosa}"?`,
            message: `Se eliminará para los ${bono.detalle?.length || 0} auxiliar(es) que lo tenían cargado.`,
            onConfirm: async () => {
                setEliminandoId(bono.id);
                try {
                    await axiosInstance.post(`/liquidacion/bono/${bono.id}/eliminar`);
                    await fetchBonos();
                    if (onChange) onChange();
                } catch (err) {
                    console.error(err);
                    alert("No se pudo eliminar el bono.");
                } finally {
                    setEliminandoId(null);
                }
            },
            onCancel: () => {}
        });
    };

    return (
        <>
            <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                <i className="bi bi-gift me-2"></i>
                                Bonos Cargados - {periodo} ({tipo === "adelanto" ? "Adelanto" : "Fin de Mes"})
                            </h5>
                            <button className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            {loading && <div className="text-muted">Cargando...</div>}

                            {!loading && bonos.length === 0 && (
                                <div className="text-muted">No hay bonos cargados en este periodo.</div>
                            )}

                            {!loading && bonos.length > 0 && (
                                <table className="table table-sm align-middle">
                                    <thead>
                                        <tr>
                                            <th>Glosa</th>
                                            <th className="text-center">Auxiliares</th>
                                            <th className="text-end">Total Bruto</th>
                                            <th>Cargado</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bonos.map(bono => {
                                            const totalBruto = (bono.detalle || []).reduce(
                                                (sum, d) => sum + (Number(d.monto_bruto) || 0), 0
                                            );
                                            return (
                                                <tr key={bono.id}>
                                                    <td className="fw-bold">{bono.glosa}</td>
                                                    <td className="text-center">{bono.detalle?.length || 0}</td>
                                                    <td className="text-end">${formatMoney(totalBruto)}</td>
                                                    <td className="small text-muted">{formatDateTime(bono.fecha_carga)}</td>
                                                    <td className="text-end">
                                                        <button
                                                            className="btn btn-sm btn-outline-primary me-2"
                                                            onClick={() => setBonoAResubir(bono)}
                                                            disabled={eliminandoId === bono.id}
                                                        >
                                                            <i className="bi bi-upload me-1"></i>Resubir
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={() => handleEliminar(bono)}
                                                            disabled={eliminandoId === bono.id}
                                                        >
                                                            {eliminandoId === bono.id ? (
                                                                <span className="spinner-border spinner-border-sm"></span>
                                                            ) : (
                                                                <><i className="bi bi-trash me-1"></i>Eliminar</>
                                                            )}
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>

            <BonosCargaModal
                visible={!!bonoAResubir}
                onClose={() => setBonoAResubir(null)}
                periodo={periodo}
                tipo={tipo}
                resultadosBase={resultadosBase}
                editingBono={bonoAResubir}
                onSuccess={() => {
                    fetchBonos();
                    if (onChange) onChange();
                }}
            />
        </>
    );
};

export default BonosListadoModal;
